import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import GridPopupMenu from "./GridPopupMenu";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import * as faRegular from "@fortawesome/free-regular-svg-icons";
import * as faSolid from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";

export default function CategoricalCell(props: any) {
  const ref = useRef(null);
  const [show, setShow] = useState(false);

  const iconColor = show ? "black" : "#ccc";

  const popupIcon = props.formattedValue ?           
    <FontAwesomeIcon
      icon={show ? faRegular.faCaretSquareDown : faSolid.faCaretSquareDown }
      style={{color: iconColor}}
      fontSize="120%"
      onClick={() => setShow(!show)}        
      fixedWidth={true}
      title={"Click to filter data by this value (" + props.tooltipValue + ")"}
    /> : null;

  useEffect(() => {
    const handleClickOutside = (event:any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShow(false);
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [ ]);

  return (
    <td
      key={props.tdkey}
      style={{...props.style, verticalAlign: "middle"}}
      align={props.align}
    >
      <div ref={ref} style={{float: "right", marginRight: "-0px", cursor: "pointer"}}>
          <OverlayTrigger
            trigger="click"
            key={"overlayTrigger-" + props.tdkey}
            placement={"bottom-start"}
            rootClose={true}
            delay={0}
            show={show}
            overlay={
              <Popover id={"popover-" + props.tdkey}>
                <Popover.Content style={{ padding: "5px 0" }}>
                  <GridPopupMenu
                    tdkey={props.tdkey}
                    filteredColumn={props.filteredColumn}
                    cellValue={props.cellValue}
                    formattedValue={props.tooltipValue}    
                    hideMenu={() => setShow(false)}
                    categoricalCellDto={props.categoricalCellDto}
                    currentUser={props.currentUser}
                  />
                </Popover.Content>
              </Popover>
            }
          >
            {({ ref, ...triggerHandler }) => (
              <span {...triggerHandler} ref={ref}>
                {popupIcon}
              </span>
            )}
          </OverlayTrigger>
        </div>
        <div style={{marginRight: "20px", overflow: "clip", whiteSpace: "nowrap", textOverflow: "ellipsis"}} title={props.tooltipValue}>
          {props.formattedValue}
        </div>
    </td>
  );
}